import { ITeam } from 'src/app/shared/models/team/iteam';
import { PositionWrite } from 'src/app/shared/models/team/positionWrite';
import { AttributeWrite } from 'src/app/shared/models/attributes/attributeWrite';

export class TeamWrite implements ITeam {
  public id: string;
  public name: string;
  public publicName: string;
  public startDate: Date;
  public endDate: Date;
  public positions: PositionWrite[];
  public attributes: AttributeWrite[] = new Array<AttributeWrite>();

  constructor(
    id: string,
    name: string,
    publicName: string,
    positions: PositionWrite[],
    attributes: AttributeWrite[],
    startDate?: Date,
    endDate?: Date
  ) {
    this.id = id;
    this.name = name;
    this.publicName = publicName;
    this.startDate = startDate || null;
    this.endDate = endDate || null;
    this.positions = positions;
    this.attributes = attributes;
  }
}
